import { KnowledgeBase } from '@edwin-group/people-graphql';
import GenericKnowledgeBaseCard from './GenericKnowledgeBase';

const KnowledgeBaseCard = ({
  knowledgebase,
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  knowledgebase: KnowledgeBase;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  return (
    <GenericKnowledgeBaseCard
      knowledgebase={knowledgebase}
      showBookmarkIcon={showBookmarkIcon}
      onRemoveFromBookmark={onRemoveFromBookmark}
    />
  );
};

export default KnowledgeBaseCard;
